import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {TimelineComponent} from "../../elements/timeline/timeline.component";
import {SearchPlacesComponent} from "../../elements/searh-places/search-places.component";
import {NgIf} from "@angular/common";
import {OldMapComponent} from "../../elements/old-map/old-map.component";
import {IconComponent} from "../../elements/icon/icon.component";
import {Icons} from "../../../model/icon";
import {Article} from "../../../model/article";
import {getRandomElement} from "../../../functions/getRandom";
import {Router} from "@angular/router";
import {FullScreenSliderComponent} from "../../elements/full-screen-slider/full-screen-slider.component";
import {PanoramaComponent} from "../panorama/panorama.component";
import {panoramas} from "../../../model/panorama";
import {ChronologyService} from "../../../services/chronology-service";
import {MapFilter} from "../../../model/chronology";
import {ApiService} from "../../../services/api.service";
import {getImageUrl} from "../../../functions/getImageUrl";

@Component({
  selector: 'app-map-page',
    imports: [
        TimelineComponent,
        SearchPlacesComponent,
        NgIf,
        OldMapComponent,
        IconComponent,
        FullScreenSliderComponent,
        PanoramaComponent
    ],
  templateUrl: './map-page.component.html',
  styleUrl: './map-page.component.scss'
})
export class MapPageComponent implements OnInit, AfterViewInit{

    @ViewChild(OldMapComponent) oldMapComponent!: OldMapComponent;
    @ViewChild(TimelineComponent) timelineComponent!: TimelineComponent;
    constructor(private readonly router: Router,
                private readonly chronologyService: ChronologyService,
                private apiService: ApiService,
    ) {}

    article: Article = new Article();

    activeInfo: boolean = false;
    activeFilter: boolean = false;

    panorama: boolean = false;
    panoramaKey: string = '';

    activeFullScreen: boolean = false;
    activePhotoIndex: number = 0;
    activePhoto: string = '';
    activePhotos: string[] = [];

    filter: MapFilter = new MapFilter();

    articles: Article[] = [];

    search(value: string) {
       this.oldMapComponent.filter(value);
       this.filter.search = value;
       this.chronologyService.setMapFilter(this.filter);
    }

    activate(key: string) {
       const idx = Number(key.replaceAll('articleId-', ''));
       this.setActive(idx);
    }

    activateInfo() {
        this.activeInfo = !this.activeInfo;
    }

    filterByType(arr: string[]) {
        this.filter.filters = arr;
        this.chronologyService.setMapFilter(this.filter);
        this.oldMapComponent.setFilter(arr);
    }

    setActive(index: number) {
        const idx = this.articles.findIndex(v => v.id == index);
        if (idx > -1) {
            this.activeInfo = true;
            this.article = this.articles[idx];
            if (this.article.timelineId) {
                const year = Math.floor(this.article.timelineId / 12);
                const month = this.article.timelineId % 12;
                this.timelineComponent.sliderSelect(year, month);
            }
        } else {
            console.log('not found');
        }
    }

    setActiveByTimeline(timeLineId: number) {
        const idx = this.articles.findIndex(v => v.timelineId == timeLineId);
        if (idx > -1) {
            this.activeInfo = true;
            this.article = this.articles[idx];
            if (this.article.timelineId) {
                const year = Math.floor(this.article.timelineId / 12);
                const month = this.article.timelineId % 12;
                this.timelineComponent.sliderSelect(year, month);
            }
        } else {
            console.log('not found');
        }
    }

    setActiveByMap() {
        const randomArticle = getRandomElement(this.articles);
        if (randomArticle?.timelineId) {
            this.setActive(randomArticle.timelineId);
        }
    }

    goToChronology() {
        const id = this.article.id;
        this.chronologyService.setActiveChronology(id);
        this.router.navigate(['/chronology'],).then();
    }

    getImg() {
        const arr = this.article.images ?? [];
        if (arr.length > 0) {
            return getImageUrl(arr[0]);
        } else return undefined;
    }

    fullScreenSlider() {
        const ar = this.article;
        if (ar.imgs) {
            if (ar.imgs.length > 0) {
                this.activePhotos = ar.imgs;
                this.activePhoto = this.activePhotos[0];
                this.activeFullScreen = true;
            }
        } else if (ar.img) {
            this.activePhotos = [];
            this.activePhotos.push(ar.img);
            this.activePhoto = this.activePhotos[0];
            this.activeFullScreen = true;
        }
    }


    nextPhoto() {
        this.activePhotoIndex = this.activePhotoIndex - 1;
        if (this.activePhotoIndex < 0) {
            this.activePhotoIndex = this.activePhotos.length - 1;
        }
        this.activePhoto = this.activePhotos[this.activePhotoIndex];

    }

    prevPhoto() {
        this.activePhotoIndex = this.activePhotoIndex + 1;
        if (this.activePhotoIndex > this.activePhotos.length - 1) {
            this.activePhotoIndex = 0;
        }
        this.activePhoto = this.activePhotos[this.activePhotoIndex];
    }

    panoramaActivate(key: string) {
        const id = Number(key.replaceAll('panoramaId-', ''));
        if (id > -1) {
            const panorama = panoramas.find(v => v.id == id);
            if (panorama) {
                setTimeout(()=> {
                    this.panoramaKey = panorama.key;
                    this.panorama = true;
                }, 500);
            }
        }
    }

    panoramaInactivate() {
        this.panorama = false;
    }

    ngOnInit() {
        this.filter = this.chronologyService.getMapFilter();
    }

    ngAfterViewInit() {
        this.apiService.getPaginatedData('public/chronology', 1, 1000, '').subscribe((data) => {
            this.articles = data.content.map((v: any) => new Article(v));
            setTimeout(() => {
                this.oldMapComponent.filter(this.filter.search ?? '', this.articles);
            }, 200);
        });
    }


    protected readonly Icons = Icons;
}
